import { getEndpoint } from '../endpoints';
import { commonFields } from '../../utils/commonFields';
import { veSpecificFields } from '../../utils/veSpecificFields';
import { attachmentFields } from '../../utils/attachmentFields';

export const ve = {
    state: {
        veForm: {
            ...commonFields,
            ...veSpecificFields,
            ...attachmentFields,
        },
    },
    getters: {
        getVeForm(state) {
            return state.veForm;
        },
    },
    actions: {
        async getRequestVeById({ rootState, commit, dispatch }) {
            const { controlId: reqControlId, propertyId: reqPropertyId } = rootState.route.params;
            const storedControlId = (rootState.refControls.controls[0] || {}).id || null;
            const storedPropertyId = rootState.refProperties.property.id || null;
            const setControl = (controlId) => {
                const control = rootState.refControls.controls.find(
                    value => value.id === controlId
                );

                if (!control) {
                    return;
                }

                commit('setControl', control);
                commit('setVeForm', control.data);
            };

            const needToRefetch = reqControlId !== storedControlId || reqPropertyId !== storedPropertyId;

            if (needToRefetch) {
                dispatch('fetchProperty', { id: rootState.route.params.propertyId });
                dispatch('setIdProperty', { id: rootState.route.params.propertyId });
                dispatch('fetchControls', { id: rootState.route.params.propertyId }).then(() => {
                   setControl(reqControlId);
                });

                return;
            }

            setControl(reqControlId);
        },
        async submitVe({ rootState, dispatch, commit, state }, payload) {
            let formData = new FormData();
            const endpoint = getEndpoint(rootState.app.typeForm, null, rootState.route.params.controlId)[
                payload.action
            ];
            commit('addExtratFieldsToForm', { property: rootState.refProperties.property });
            Object.entries(state.veForm).map(([key, values]) => {
                var exisitingFiles = [];
                if (Array.isArray(values)) {
                    values.forEach((fileElement, index) => {
                        if (fileElement instanceof File) {
                            formData.append(key + '[' + index + ']', fileElement);
                        } else if (fileElement) {
                            delete fileElement.manuallyAdded;
                            delete fileElement._removeLink;
                            exisitingFiles.push(fileElement);
                        }
                    });
                    state.veForm[key] = exisitingFiles.slice();
                }
            });

            if (state.veForm.signature && !state.veForm.signature.startsWith('data:')) {
                state.veForm.signature = null;
            }
            state.veForm.folderNumberLong = rootState.refProperties.property.folderNumberLong;
            formData.append('data', JSON.stringify(state.veForm));
            dispatch('postFormRoute', { endpoint, form: formData });
        },
        handleSubmitVe({ dispatch }) {
            dispatch('submitVe', { action: `create` });
        },
        handleSubmitEditVe({ dispatch }) {
            dispatch('submitVe', { action: `edit` });
        },
        initVeForm({ commit }) {
            commit('initVeForm');
        },
    },
    mutations: {
        setVeForm(state, payload) {
            Object.entries(payload).map(([key, val]) => {
                if (val && typeof val === 'object' && val.constructor === Object) {
                    if (typeof val.id !== 'undefined') {
                        payload[key] = val.id;
                    }
                }
            });
            state.veForm = payload;
        },
        initVeForm(state) {
            state.veForm = { ...commonFields, ...veSpecificFields, ...attachmentFields };
        },
        addExtratFieldsToForm(state, payload) {
            state.veForm.property = payload.property;
            state.veForm.user = null;
            if (state.veForm.contact !== null) {
                var contact = state.veForm.property.contacts.find(function (contact) {
                    return contact.id == state.veForm.contact;
                });
                state.veForm.contact = new Object();
                state.veForm.contact.id = contact.id;
                state.veForm.contact.address = `${contact.numberStreet} ${contact.zipCode} ${contact.town}`;
                state.veForm.contact.email = contact.email;
                state.veForm.contact.firstName = contact.firstName;
                state.veForm.contact.lastName = contact.name;
                state.veForm.contact.mobileNumber = contact.mobilePhone;
                state.veForm.contact.phoneNumber = contact.fixedLinePhone;
            }
        },
    },
};
